import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import log from 'loglevel';

const MixpanelContext = React.createContext();

const MixPanelProvider = ({ children, projectToken }) => {
  const mixpanelRef = useRef();

  if (!mixpanelRef.current && projectToken) {
    mixpanel.init(projectToken);
    mixpanelRef.current = mixpanel;
  }

  return (
    <MixpanelContext.Provider value={mixpanelRef.current}>{children}</MixpanelContext.Provider>
  );
};

const useMixpanel = () => {
  const context = React.useContext(MixpanelContext);
  if (context === undefined) {
    log.error('useMixpanel must be used within a MixPanelProvider');
  }
  return context;
};

export { useMixpanel, MixpanelContext, MixPanelProvider };

MixPanelProvider.propTypes = {
  children: PropTypes.any,
  projectToken: PropTypes.string,
};

export default MixPanelProvider;
